import GlobalStylesMui from '@mui/material/GlobalStyles';

import themeConfig from '@config/theme.config';

const globalStyles = {
  '*, *::before, *::after': {
    boxSizing: 'border-box',
  },
  html: {
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    height: '100%',
  },
  body: {
    height: '100%',
    margin: 0,
  },
  '#root': {
    minHeight: '100%',
  },
  'img, picture, video, canvas, svg': {
    display: 'block',
    maxWidth: '100%',
  },
  'input, button, textarea, select': {
    font: 'inherit',
  },
  'button:focus-visible, a:focus-visible, [tabindex]:focus-visible': {
    outline: `2px solid ${themeConfig.primaryColor}`,
    outlineOffset: '2px',
  },
};

function GlobalStyles() {
  return <GlobalStylesMui styles={globalStyles} />;
}

export default GlobalStyles;
